import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { MapTooltip } from "../../../widgets/map/mapAddons/mapTooltip";
import { getBasicObjectTypeLayer } from "../../../widgets/map/mapFeatures/layers";
import { copyInfoFromTooltip, showMapTooltip } from "../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../stateManagement/reducers/MapTooltipSlice";
import TableUnderMapSingleType  from "../../tables/tableUnderMap/TableUnderMapSingleType";
import { mapLayersDict } from "../mapLayersDict";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapHighwayNetworkSegments() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const objectType = "HighwayNetworkSegments"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[objectType] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace)
        setAdditionalLayers([objectTypeLayer])
    }, [objectType]);

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, 'highwayNetworkSegments', additionalLayers[0], map)
        const activeTooltipClick = (event: any) => copyInfoFromTooltip()
        map?.on("pointermove", pointerMoveFunc)
        map?.on("singleclick", activeTooltipClick)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                map?.un("singleclick", activeTooltipClick)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={objectType} type="map" />
            <div className="map-widget-with-toast">
                <MapTooltip type={objectType} />
                <MapWidget additionalLayers={additionalLayers} mapEventHandlers={mapEventHandlers} mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null} />
                <MapOverlayWidget />
                {tableUnderMapIsShown && <TableUnderMapSingleType  objectType={objectType} />}
            </div>
        </>
    )
}
